import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const faqs = [
  {
    q: "Is registration free?",
    a: "Yes. You can start with free tools like Admission Eligibility Checker and Holiday/Event Checker at no cost.",
  },
  {
    q: "Do I need to pay immediately?",
    a: "No. Payment is only required to unlock premium tools. You can use free tools without any payment.",
  },
  {
    q: "Will the app work on normal smartphones?",
    a: "Yes. The app is designed for all Android phones, including budget smartphones. It works smoothly even on slower internet.",
  },
  {
    q: "What premium tools are included?",
    a: "Premium includes MDM Daily Calculator, Nutrition Ladoo Calculator, Marks Percentage Calculator, GST Calculator, MDM Message Generator, and Application Writer.",
  },
  {
    q: "How much does premium cost?",
    a: "Premium access costs only ₹199 per year — less than ₹4 per week for tools that save you hours of work.",
  },
  {
    q: "Can I contact support if I have a problem?",
    a: "Yes. You can reach us directly on WhatsApp for any questions or support. We're here to help!",
  },
];

export default function FAQSection() {
  return (
    <section data-testid="faq-section" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="flex items-center justify-center gap-2 mb-3">
          <HelpCircle className="w-5 h-5 text-green-600" />
          <span className="text-green-700 font-semibold text-sm uppercase tracking-wide">FAQ</span>
        </div>
        <h2
          data-testid="faq-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Frequently Asked Questions
        </h2>

        <Accordion type="single" collapsible className="mt-10">
          {faqs.map((faq, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-sm md:text-base font-medium text-slate-800 hover:text-green-700">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-600 leading-relaxed">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
